import React from 'react';
import { Box, Typography } from '@mui/material';
const Footer = () => {
    return (
        <Box>
            <Typography 
                align='center' 
                sx={{
                    paddingBottom: {
                        xs: '2.5vw',
                        md: '16px'
                    }   
                }}
            >
                This site was made with React and MUI.
            </Typography>
        </Box>
    );
};

export default Footer;